/**
 * Who an invitation is for, read from the one box the Invite page has
 * (decided with Tiago 12 October): a username or an email address, told
 * apart by an `@` after the first character. No username contains one, so
 * that is an address; a single `@` in front is how people write a handle,
 * and is read as one.
 */
export function readInvitee(typed: string): { username?: string; email?: string } {
  const text = typed.trim();
  if (text === "") return {};
  if (text.indexOf("@", 1) !== -1) return { email: text };
  const username = text.startsWith("@") ? text.slice(1).trim() : text;
  return username === "" ? {} : { username };
}
